import React from 'react';

import { BoldText, ClauseText } from './Components/ContractText';

interface Props {
  personalProperty: string;
  leasedProperty: string;
  excludedPersonalItem: string;
}

const FixturesandProperty = ({
  personalProperty,
  leasedProperty,
  excludedPersonalItem,
}: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Fixtures and Personal Property
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          It is possible for certain items of personal property to be so
          integrated into the Property that they become fixtures and will be
          regarded as part of the Property and therefore included in a sale.
          Buyer and Seller are encouraged to be specific when negotiating what
          items will be included or excluded in this sale.
        </li>
        <li>
          <BoldText>INCLUDED in this sale, unless otherwise stated</BoldText>,
          are all existing items permanently installed in or on the Property,
          free of liens, and other items including plumbing; heating; gas
          fireplace logs; radiator covers; hardwired security systems;
          thermostats; lighting fixtures (including chandeliers and ceiling
          fans); pools, spas and hot tubs (including covers and cleaning
          equipment); electric animal fencing systems (excluding collars);
          garage door openers and transmitters; mounting brackets and hardware
          for television and sound equipment; unpotted shrubbery, plantings and
          trees; smoke detectors and carbon monoxide detectors; sump pumps;
          storage sheds; fences; mailboxes; wall to wall carpeting; existing
          window screens, storm windows and screen/storm doors; window covering
          hardware (including rods and brackets), shades and blinds; awnings;
          central vacuum system (with attachments); built-in air conditioners;
          built-in appliances; the range/oven; dishwashers; trash compactors;
          any remaining heating and cooking fuels stored on the Property at the
          time of settlement; and, if owned, solar panels, windmills, water
          treatment systems, propane tanks and satellite dishes. Unless stated
          otherwise, the following items are included in the sale, at no
          additional cost: <ClauseText>{personalProperty}</ClauseText>
        </li>
        <li>
          The following items are <BoldText>not owned by Seller</BoldText> and
          may be subject to a lease or other financing agreement. Contact the
          provider/vendor for more information (e.g., solar panels, windmills,
          water treatment systems, propane tanks and satellite dishes):{' '}
          <ClauseText>{leasedProperty}</ClauseText>
        </li>
        <li>
          <BoldText>EXCLUDED fixtures and items:</BoldText>{' '}
          <ClauseText>{excludedPersonalItem}</ClauseText>
        </li>
      </ol>
    </div>
  );
};

export default FixturesandProperty;
